module.exports = __webpack_public_path__ + "img/mails footer@2x.36663ee6.png";